import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  login: !!localStorage.getItem("token"),
  role: localStorage.getItem("role") || null,
  user: JSON.parse(localStorage.getItem("user") || "null"),
  LoginURL: "https://backendcherryk.kwintechnologykw11.com:4000/api/",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state,action) => {
      state.login = true;
      state.role = action.payload.user.role
    },
    addUser: (state, action) => {
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.user = action.payload;
    },
    logoutSuccess: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      state.login = false;
      state.user = "";
      state.role = null;
    },
  },
});

export const { loginSuccess, addUser, logoutSuccess } = authSlice.actions;
export default authSlice.reducer;
